import debug from 'debug';

const BASE = 'bcp-react-app';
const COLOURS = {
  trace: 'lightblue',
  info: 'blue',
  warn: 'pink',
  error: 'red'
}; // choose better colours :)

class Logger {
  static generateMessage(level, message, source) {
    // Set the prefix which will cause debug to enable the message
    const namespace = `${BASE}:${level}`;
    const createDebug = debug(namespace);

    // Set the colour of the message based on the level
    createDebug.color = COLOURS[level];

    if (source) {
      createDebug(source, message);
    } else {
      createDebug(message);
    }
  }

  static trace(message, source) {
    return Logger.generateMessage('trace', message, source);
  }

  static info(message, source) {
    return Logger.generateMessage('info', message, source);
  }

  static warning(message, source) {
    return Logger.generateMessage('warn', message, source);
  }

  static error(message, source) {
    return Logger.generateMessage('error', message, source);
  }
}

export default Logger;
